import { Modal } from "../ui/modal/Modal"
import { ModalError } from "../ui/modal/ModalError"
import { msg } from "../ui/modal/utils"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { useQuery } from "../../hooks/useQuery"
import { useTranslation, Trans } from "react-i18next"

export const ModalEliminarUsuario = ({ show, user, setUsers }) => {
  const deleteUser = useQuery()

  const handleDelete = async () => {
    const { url, opt } = await api.users.delete({
      token: getCookie("jwt"),
      user_id: user.user_id,
    })

    // ejecuto
    deleteUser.url.current = url
    deleteUser.opt.current = opt

    deleteUser.run({
      onOk: () => {
        setUsers((currents) =>
          currents.filter((u) => u.user_id !== user.user_id)
        )
        show[1](false)
      },
    })
  }

  const { t } = useTranslation()

  const modalFooter = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => show[1](false)}>
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-danger"
          disabled={deleteUser.isPending}
          onClick={() => handleDelete()}>
          {deleteUser.isPending
            ? t(`ui.btns.deleting`) + "..."
            : t(`ui.btns.yes`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="confirmar-accion"
        show={show}
        className="darkie"
        header={<center>{t(`ui.msgs.confirm_action`)}</center>}
        body={msg(
          <Trans
            i18nKey="modals.modal_delete_user.are_you_sure"
            values={{ user: user.username }}
            components={{ b: <b /> }}
          />
        )}
        footer={modalFooter()}
      />

      {/* en caso de erro, muestro una modal */}
      {deleteUser.res && deleteUser.err && (
        <ModalError show={show} res={deleteUser.res} />
      )}
    </>
  )
}
